import { ExerciseProps } from '../../../types/Exercise.type';
import { MutationExercise } from '../../../../services/exercise/MutationExercise';

export const saveExercise = async (
  exerciseValues: ExerciseProps,
  setLoading: (loading: boolean) => void,
  setProgress: (progress: number) => void
): Promise<{ exercise: ExerciseProps }> => {
  setLoading(true);
  
  try {
    const result = await MutationExercise(
      exerciseValues,
      setLoading,
      setProgress
    );
    
    return result;
  } catch (error) {
    console.error('Error saving exercise:', error);
    throw error;
  }
};

export const redirectToEditPage = (exerciseId: string): void => {
  const accountName = window.location.pathname.split('/')[1];
  window.history.pushState('object or string', '', `/${accountName}/admin/exercises/${exerciseId}/edit`);
}; 